/*eslint no-case-declarations: 0 */
import { browserHistory } from 'react-router';

import { CHECKOUT_EVENTS } from './../constants';
import ActionTypes from './types';
import {removeElement, convertSecTimeStampToMiliSec} from './../utils';
import store from './../store/configureStore';

export const handleStatusChange = (data, requestID) => {
  const {requestId, event} = store.getState().checkout;
  return (dispatch) => {
    if (requestID === requestId) {
      switch (event) {
        case CHECKOUT_EVENTS.reserve:
          dispatch(afterReserveSpot());
          break;
        case CHECKOUT_EVENTS.unreserve:
          dispatch(afterUnreserveSpot());
          break;
        case CHECKOUT_EVENTS.trade:
          dispatch(afterTradeSpot());
          break;
        case CHECKOUT_EVENTS.cancelHold:
          dispatch(afterCancelHold());
          break;
        case CHECKOUT_EVENTS.hold:
          const { expirationTS, spotid } = data.data;
          dispatch(afterHold(expirationTS, spotid));
          break;
        default:
          dispatch({
            type: ActionTypes.RESET_CHECKOUT_DATA
          });
      }
    }
  };
};

const afterDataReceive = (isCheckoutPageOpened) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.RESET_CHECKOUT_DATA
    });

    dispatch({
      type: ActionTypes.RESET_SEARCH
    });

    dispatch({
      type: ActionTypes.SET_NAV_CHECKOUT_STATE,
      isCheckoutPageOpened: false
    });

    dispatch({
      type: ActionTypes.UPDATE_TIMESTAMP,
      timeStamp: 0
    });

  };
};

const afterCancelHold = () => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.RESET_HELD_SPOTS
    });
    dispatch(afterDataReceive());
  };
};

const afterHold = (expirationTS, heldSpot) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_TIMESTAMP,
      timeStamp: convertSecTimeStampToMiliSec(expirationTS)
    });

    dispatch({
      type: ActionTypes.UPDATE_HELD_SPOTS,
      heldSpot,
    });

    dispatch({
      type: ActionTypes.SET_REQUEST_ID,
      requestId: null
    });

    dispatch({
      type: ActionTypes.RESET_CHECKOUT_LOADER
    });
  };
};

const afterReserveSpot = () => {
  const {spotToReserve} = store.getState().checkout;
  return (dispatch) => {
    let reservedSpots = store.getState().userAccommodationInfo.reservedSpots;

    if(spotToReserve) {
      reservedSpots = [...reservedSpots, spotToReserve];
    }

    dispatch({
      type: ActionTypes.SET_RESERVED_SPOTS,
      reservedSpots
    });

    dispatch(afterDataReceive());

    dispatch({
      type: ActionTypes.RESET_HELD_SPOTS
    });

    browserHistory.push('/confirmation');
  };
};

const afterTradeSpot = () => {
  const {spotToReserve, spotToUnreserve} = store.getState().checkout;
  return (dispatch) => {
    let reservedSpots = store.getState().userAccommodationInfo.reservedSpots;

    if(spotToReserve) {
      reservedSpots = [...reservedSpots, spotToReserve];
    }

    if(spotToUnreserve) {
      reservedSpots = removeElement(reservedSpots, spotToUnreserve);
    }

    dispatch(afterDataReceive());

    dispatch({
      type: ActionTypes.SET_RESERVED_SPOTS,
      reservedSpots
    });

    browserHistory.push('/confirmation');
  };
};

const afterUnreserveSpot = () => {
  const {spotToUnreserve} = store.getState().checkout;
  const newReservedSpots = removeElement(store.getState().userAccommodationInfo.reservedSpots, spotToUnreserve);

  return (dispatch) => {
    dispatch(afterDataReceive());
    dispatch({
      type: ActionTypes.SET_RESERVED_SPOTS,
      reservedSpots: newReservedSpots
    });
  };
};


export const afterErrorMessageReceived = () => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.RESET_CHECKOUT_DATA
    });

    dispatch({
      type: ActionTypes.SET_NAV_CHECKOUT_STATE,
      isCheckoutPageOpened: false
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/updateChannelSubscribe.js